import { render, staticRenderFns } from "./OrgLocations.vue?vue&type=template&id=5588f9e8&"
import script from "./OrgLocations.vue?vue&type=script&lang=js&"
export * from "./OrgLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports